import type { CustomRouteRecordRaw } from 'vue-router'
import { useSiteConfig } from '@/hooks/site-config'
import BackendLayout from '@/views/layouts/backend-layout.vue'
import { workbenchRoutes } from './workbench'
import { miniAppRoutes } from '@/router/routes/miniApp'
import { codeTemplateRoutes } from '@/router/routes/codeTemplate'

const { backendPrefix } = useSiteConfig

export const appRoutes: CustomRouteRecordRaw[] = [workbenchRoutes, miniAppRoutes, codeTemplateRoutes]

const routes: CustomRouteRecordRaw[] = [
  {
    path: '/',
    name: 'OffcailWeb',
    redirect: { name: 'login' },
  },
  {
    path: `${backendPrefix}login`,
    name: 'login',
    component: () => import('@/views/auth/login/login.vue'),
    meta: {
      title: '账号登录',
      noNeedAuth: true,
    },
  },
  {
    path: backendPrefix,
    name: 'root',
    component: BackendLayout,
    redirect: { name: 'workbench' },
    children: appRoutes,
  },
  {
    path: '/:patchMatch(.*)*',
    name: 'notFound',
    redirect: { name: 'root' },
  },
]

// 获取父路由的名字
function setParentName(routeList, parentNameList) {
  routeList.forEach(route => {
    route.meta = route.meta || {}
    route.meta.parentName = parentNameList
    route.children?.length
      && setParentName(route.children, [...parentNameList, route.name])
  })
}
setParentName(routes, [])

export default routes